import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { PublicStatesPage } from '../../PublicStatesPage'
import { editorSearchSchema } from '../search-schemas'

export const publicStatesRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/public_states',
  validateSearch: editorSearchSchema,
  component: PublicStatesRouteComponent,
})

function PublicStatesRouteComponent() {
  const search = publicStatesRoute.useSearch()
  const navigate = useNavigate()
  return (
    <PublicStatesPage
      publicStateId={search().edit ?? null}
      create={search().new === 1}
      onOpen={(id) => navigate({ to: '/public_states', search: { edit: id } })}
      onCreate={() => navigate({ to: '/public_states', search: { new: 1 } })}
      onBack={() => navigate({ to: '/public_states', search: {} })}
    />
  )
}
